import { useMemo } from "react";
import { dashboardVelocityOneRepMaxEnabled } from "config/features";
import LocalStorageHelper from "helpers/LocalStorageHelper";
import useVelocityOnBoarding from "hooks/useVelocityOnBoarding";

/**
 * Hotspot on the Dashboards sidebar item announcing velocity-based 1RM.
 * Dismissed once the Dashboards page is visited.
 */
function useDashboardVelocityHotspot() {
  const { open, dismiss } = useVelocityOnBoarding(LocalStorageHelper.keys.showDashboardVelocityHotspot);

  return useMemo(() => ({ open: dashboardVelocityOneRepMaxEnabled && open, dismiss }), [dismiss, open]);
}

export default useDashboardVelocityHotspot;
